
const lang = {
	en: {
		Search: "Search",
		gptplaceholder: "What Would You like to Watch Today ?",
	},
	hindi: {
		Search: "खोज",
		gptplaceholder: "आज आप क्या देखना चाहेंगे ?",
	},
	bhoj: {
		Search: "तलाशी",
		gptplaceholder: "आज रउवा का देखल चाहब ?",
	},
};

export default lang;